import { io } from "socket.io-client";
import config from "../config";

let socket;

export const connectSocket = (queryParams) => {
  socket = io(config.REACT_APP_HOST_WEBSOCKET, { query: queryParams });
  return socket;
};

/** Retorna a instância do socket ou null se ainda não conectado (evita erro ao restaurar sessão no refresh). */
export const getSocket = () => {
  return socket || null;
};

export const enviarNotificacao = async (dadosNotificacao) => {
  const s = getSocket();
  if (!s) return;
  s.emit("criar-notificacao", {
    titulo: dadosNotificacao.titulo,
    texto: dadosNotificacao.texto,
    grupos: dadosNotificacao.grupos,
    usuarios: dadosNotificacao.usuarios,
    path: dadosNotificacao.path,
    tipo: dadosNotificacao.tipo,
  });
};
